import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [1, 2, 3, 4, 5];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-24">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          {t('faq.title')}
        </h2>
        <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('faq.sub')}</p>
      </div>

      <div className="mt-10 space-y-3">
        {faqItems.map((n, idx) => (
          <div
            key={n}
            className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              className="flex w-full items-center justify-between px-5 py-4 text-left"
              aria-expanded={openIndex === idx}
            >
              <span className="pr-4 text-sm font-semibold text-foreground-900 md:text-base">
                {t(`faq.${n}.q`)}
              </span>
              <i
                className={`ri-add-line w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform ${openIndex === idx ? 'rotate-45' : ''}`}
              ></i>
            </button>
            {openIndex === idx && (
              <div className="px-5 pb-5">
                <p className="text-sm leading-relaxed text-foreground-600">{t(`faq.${n}.a`)}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}